app.controller('AssignProgramToolbarController', function($scope, $uibModal, $http, loginService) {
    this.user = loginService.currentUser;
    $scope.programId = '';
    this.openAssignModal = () => {
        $uibModal
            .open({
                component: 'client-select',
                windowClass: 'client-select-modal',
                animation: false,
                size: 'md',
            })
            .result
            .then(onClientSelect, onCancel)
            .catch(onError('client-select'));
    };

    this.openOrderSelectModal = (client, orders) => {
        $uibModal
            .open({
                component: 'order-select',
                windowClass: 'order-select-modal',
                animation: false,
                size: 'md',
                resolve: {
                    client: () => {
                        return client;
                    }, 
                    orders: () => {
                        return orders;
                    }
                }
            })
            .result
            .then(onOrderSelect, onCancel)
            .catch(onError('order-select'));
    };

    this.openSendOfferModal = (client) => {
        $uibModal
            .open({
                component: 'send-offer',
                windowClass: 'send-offer-modal',
                animation: false,
                size: 'md',
                resolve: {
                    client: () => {
                        return client;
                    }
                }
            })
            .result
            .then(onOrderSend, onCancel)
            .catch(onError('send-offer'));
    };

    this.openOrderCompleteModal = (client) => {
        $uibModal
            .open({
                component: 'order-complete',
                windowClass: 'order-complete-modal',
                animation: false,
                size: 'md',
                resolve: {
                    client: () => {
                        return client;
                    }
                }
            })
            .result
            .then(onCancel, onCancel)
            .catch(onError('order-complete'));
    };

    this.openOrderSendCompleteModal = (client) => {
        $uibModal
            .open({
                component: 'order-send-complete',
                windowClass: 'order-send-complete-modal',
                animation: false,
                size: 'md',
                resolve: {
                    client: () => {
                        return client;
                    }
                }
            })
            .result
            .then(onCancel, onCancel)
            .catch(onError('order-send-complete'));
    };

    const onOrderSend = (data) => {
        // console.log(data);
        const clientId = data.client._id;
        const description = data.description;
        const price = data.price;
        const currency = data.currency;
        const programId = $scope.programId;
        this.loading = true;

        const reqBody = {
            description: description,
            price: price,
            currency: currency
        };

        $http
            .post(`/offer/send/${clientId}/${programId}`, reqBody)
            .then((response) => {
                // console.log(response);
                this.openOrderSendCompleteModal(data.client);
            })
            .finally(() => {
                this.loading = false;
            });
    };

    const onOrderSelect = (data) => {
        const clientId = data.client._id;
        const orderId = data.order.id;
        const programId = $scope.programId;

        this.loading = true;
        $http
            .post(`/purchase/program/${clientId}/${orderId}/${programId}`)
            .then((response) => {
                window.location.reload();
                // this.openOrderCompleteModal(data.client);
            })
            .finally(() => {
                this.loading = false;
            });
    };

    const onClientSelect = (client) => {
        this.loading = true;
        $http
            .get(`/orders/program/client/${client._id}`)
            .then((response) => {
                const orders = response.data;
                if (orders.length) {
                    this.openOrderSelectModal(client, orders);
                } else {
                    this.openSendOfferModal(client);
                }
            })
            .finally(() => {
                this.loading = false;
            });
    };

    const onCancel = () => {
        console.log('cancel action performed');
    };

    const onError = (name) => {
        return (err) => {
            console.log('',err);
        };
    };

});
